module.exports = __webpack_public_path__ + "media/images/flags/ml-18083e46073cc9f5f58fda59451b15f9.svg";